export default __webpack_public_path__ + "static/media/type_document_logo.7ba63b70.svg";